import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "../firebase";
import { requestMagicLink, useAuth } from "../auth";

export default function SignIn() {
  const { uid } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const nav = useNavigate();

  if (uid) { nav("/app"); return null; }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    try {
      await requestMagicLink(email);
      setSent(true);
    } catch (err) {
      setError(String((err as { message?: string }).message ?? err));
    }
  }

  async function google() {
    setError("");
    try {
      await signInWithPopup(auth, new GoogleAuthProvider());
    } catch (err) {
      setError(String((err as { message?: string }).message ?? err));
    }
  }

  return (
    <div className="shell">
      <h1>Sign in to VocabKit</h1>
      <p className="muted">We email a sign-in link — no passwords. Accounts belong to parents.</p>
      {sent ? (
        <div className="card ok">Check your email and click the link to finish signing in.</div>
      ) : (
        <form onSubmit={submit} className="card">
          <label>
            Parent email
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
          </label>
          <p><button type="submit">Email me a sign-in link</button></p>
          {error && <p className="err">{error}</p>}
        </form>
      )}
      <p className="or-divider"><span>or</span></p>
      <p><button className="ghost google-btn" onClick={google}>
        <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.14-.76-2.36-.76-3.59s.27-2.45.76-3.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
        Continue with Google
      </button></p>
    </div>
  );
}
